export const CACHE_VERSION = "v1.2.19";
